import React from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import NKRHeader from "../Component/NKRHeader";
import NKRFooter from "../Component/NKRFooter";
const Sports = () => {
  useEffect(() => {
    document.title = "Sports -  Gayatri International School";
  }, []);
  return (
    <>
      <NKRHeader />
      <section className="page-header-fb innerslide">
        <div className="innerslide">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/innerslide1.gif"
              className="img-fluid"
            />
          </LazyLoad>{" "}
        </div>
        <div className="page-header__inner">
          <h2>Sports</h2>
          <ul className="thm-breadcrumb list-unstyled ml-0">
            <li>
              <Link to="/Nekhpur/Home">Home</Link>
            </li>
            <li>|</li>
            <li>Facilities</li>
            <li>|</li>
            <li>Sports</li>
          </ul>
        </div>
      </section>
      <section className="innerbody">
        <div className="container">
          <div className="row">
            <div className="col-md-12 lagimg">
              <p>
                <b>
                  "A thon of sports excitement of students in Pre-Primary wing
                  at Gayatri International School"
                </b>
              </p>
              <p>
                {" "}
                At Gayatri International School, the pre-primary wing geared up
                for an exhilarating sports extravaganza first time in the city
                farrukhabad. Gayatri international school recognizes the
                integral role that sports play in the holistic development of
                young minds, fostering physical fitness, teamwork, and a spirit
                of healthy competition. The sports-a-thon-2023 event is designed
                to captivate the enthusiasm of our youngest learners, providing
                them with a platform to explore their physical abilities and
                instill a love for an active lifestyle from an early age. The
                event is set to be a culmination of fun, learning, and skill
                development, offering an array of activities tailored to suit
                the dynamic energy of our pre-primary students. Our young
                champions engaged in a variety of age-appropriate sports and
                games, carefully curated to enhance their motor skills,
                coordination, and social interactions. From relay races that
                promote teamwork to simple ball games that improve hand-eye
                coordination, the sports-a-thon 2023 promises a range of
                activities aimed at creating a well-rounded foundation for our
                little athletes at GIS. The school is committed to fostering a
                sense of sportsmanship among its students. Beyond the physical
                benefits, sports also impart essential life skill s such as
                discipline, resilience, and the ability to gracefully accept
                both victory and defeat. Through the sports-a-thon, we aim to
                instill these values in our pre-primary learners, laying the
                groundwork for their future success, both on and offthe playing
                field. In addition to the physical activities, the event will
                feature interactive sessions led by experienced coaches and
                educators who specialize in early childhood development. These
                sessions will focus on fostering a positive attitude towards
                sports, emphasizing the joy of participation rather than solely
                focusing on winning. The school believes in creating a
                collaborative environment where parents and teachers work hand
                in hand to nurture the potential of every child. As we embark on
                this exciting journey of the sports-a-thon 2023 in the
                pre-primary wing, we look forward to witnessing the growth, joy
                and camaraderie that sports bring into the lives of our youngest
                students. Through this initiative, Gayatri International School
                aims to set the stage for a lifelong love for physical activity,
                teamwork, and the values that sports instill in our budding
                athletes.
              </p>

              <div className="row">
                <div className="col-md-3">
                  <a
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/sports1.jpg"
                  >
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/sports1.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
                <div className="col-md-3">
                  <a
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/sports2.jpg"
                  >
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/sports2.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
                <div className="col-md-3">
                  <a
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/sports3.jpg"
                  >
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/sports3.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
                <div className="col-md-3">
                  <a
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/sports4.jpg"
                  >
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/sports4.jpg"
                      className="img-fluid"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <NKRFooter />
    </>
  );
};

export default Sports;
